import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AssistantWidget } from "./components/AssistantWidget";
import { MobileAuthProvider } from "./context/MobileAuthContext";
import Landing from "./pages/Landing";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import GeoMapsPrivacy from "./pages/GeoMapsPrivacy";
import DataDeletion from "./pages/DataDeletion";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminApp from "./pages/AdminApp";
import "./App.css";

function App() {
  return (
    <div className="App">
      <MobileAuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-center" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/geo-maps-privacy" element={<GeoMapsPrivacy />} />
            <Route path="/data-deletion" element={<DataDeletion />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminApp />} />
          </Routes>
          <AssistantWidget />
        </BrowserRouter>
      </MobileAuthProvider>
    </div>
  );
}

export default App;
